module.exports = __webpack_public_path__ + "img/pic-3.21675c9a.jpg";